import { useState } from "react";
import { request } from "../../utils";
import { Modal } from "../ui/modal";
import Alert from "../ui/alert/Alert";
import Button from "../ui/button/Button";
import PinInput from "../form/input/PinInput";
import { autoClearError, validateCreatePin } from "../../utils/helpers";


interface SetPinProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export default function CreatePinModal({
  isOpen,
  onClose,
onSuccess,
}: SetPinProps) {
  const [pin, setPin] = useState("");
  const [confirmPin, setConfirmPin] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const closeModal = () => {
    onClose();
    setPin("");
    setConfirmPin("");
    setLoading(false);
    setError("");
    setSuccess("");
  };


  const handleCreatePin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    const validationError = validateCreatePin({
      pin,
      confirmPin,
    });

    if (validationError) {
      setError(validationError);
      autoClearError(setError);
      setLoading(false);
      return;
    }

    try {
      await request.post({
        url: "/user/pin",
        data: { pin, confirmPin },
      });

      setSuccess("PIN created successfully.");
      onSuccess();
      
    } catch (err) {
      setError((err as any).message || "Failed to set PIN.");

      setTimeout(() => {
        setError("");
      }, 3000)
    } finally {
      setLoading(false);
    }
  };


  return (
    <Modal isOpen={isOpen} onClose={closeModal} className="max-w-md p-6">
      <form onSubmit={handleCreatePin}>
        <div className="space-y-6">
          <h2 className="text-xl font-semibold text-gray-800 dark:text-white">
            Create 4-digit PIN
          </h2>

          {error && <Alert variant="error" title="Error" message={error} />}
          {success && (
            <Alert variant="success" title="Success" message={success} />
          )}

          <div>
            <PinInput
            label="PIN"
              value={pin}
              onChange={setPin}
            />            
          </div>

          <div>
            <PinInput
              label="Confirm PIN"
              value={confirmPin}
              onChange={setConfirmPin}
            />
          </div>

          <div>
            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? "Creating PIN..." : "Create PIN"}
            </Button>
          </div>
        </div>
      </form>
    </Modal>
  );
}
